<template>
  <div class="bg-white p-4 rounded-lg shadow">
   

    <div
      class="flex justify-between items-center mb-3 cursor-pointer"
      @click="toggleHistoryPath"
    >
     <h2 class="text-xl font-semibold text-brand-700 mb-4">Status Timeline</h2>
      <svg
        class="w-5 h-5 text-brand-700 transition-transform duration-200"
        :class="{ 'transform rotate-180': historyExpanded }"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
          clip-rule="evenodd"
        />
      </svg>
    </div>

    <div class="flex flex-col space-y-6" v-show="historyExpanded">
      <div class="space-y-4">
        <div
          v-for="(event, index) in combinedTimeline"
          :key="'event-' + index"
          class="flex items-start"
        >
          <div class="flex flex-col items-center mr-4">
            <div
              class="w-3 h-3 rounded-full"
              :class="{
                'bg-accent-500': index === 0,
                'bg-brand-600': index !== 0 && event.type === 'reassignment',
                'bg-gray-300': index !== 0 && event.type !== 'reassignment',
              }"
            ></div>
            <div
              v-if="index < combinedTimeline.length - 1"
              class="w-0.5 h-8 bg-brand-100 mt-1"
            ></div>
          </div>

          <div class="flex-1">
            <div class="flex justify-between items-baseline">
              <div>
                <span class="font-medium text-gray-900">
                  {{ event.displayText }}
                </span>
                <span
                  v-if="event.type === 'reassignment'"
                  class="ml-2 text-xs text-brand-600"
                  >(Reassigned)</span
                >
              </div>
              <span class="text-xs text-gray-500">{{
                formatDate(event.date)
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref } from "vue";

export default {
  props: {
    statusHistory: {
      type: Array,
      default: () => [],
    },
    reassignedByHistory: {
      type: Array,
      default: () => [],
    },
    initiallyExpanded: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const historyExpanded = ref(props.initiallyExpanded);

    const toggleHistoryPath = () => {
      historyExpanded.value = !historyExpanded.value;
    };
    const combinedTimeline = computed(() => {
      const timeline = [];

      props.statusHistory.forEach((status) => {
        timeline.push({
          type: "status",
          displayText: `${status.displayValue}`,
          date: status.modifiedAt,
          changedBy: status.modifiedBy.name || status.modifiedBy.email,
          rawStatus: status.value,
        });
      });

      props.reassignedByHistory.forEach((reassign) => {
        const matchingStatusIndex = timeline.findIndex(
          (event) =>
            event.type === "status" &&
            event.rawStatus === "Re-assigned" &&
            Math.abs(new Date(event.date) - new Date(reassign.modifiedAt)) <
              60000
        );

        if (matchingStatusIndex !== -1) {
          timeline[matchingStatusIndex].displayText = `Re-assigned by ${
            reassign.displayValue || reassign.value
          }`;
          timeline[matchingStatusIndex].assignedTo =
            reassign.displayValue || reassign.value;
          timeline[matchingStatusIndex].changedBy =
            reassign.modifiedBy.name || reassign.modifiedBy.email;
          timeline[matchingStatusIndex].type = "reassignment";
        } else {
          timeline.push({
            type: "reassignment",
            displayText: `Re-assigned by ${
              reassign.displayValue || reassign.value
            }`,
            date: reassign.modifiedAt,
            changedBy: reassign.modifiedBy.name || reassign.modifiedBy.email,
            assignedTo: reassign.displayValue || reassign.value,
          });
        }
      });

      return timeline.sort((a, b) => new Date(b.date) - new Date(a.date));
    });

    const formatDate = (dateString) => {
      if (!dateString) return "";
      const options = {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };
      return new Date(dateString).toLocaleDateString(undefined, options);
    };
    return {
      combinedTimeline,
      toggleHistoryPath,
      formatDate,
      historyExpanded,
    };
  },
};
</script>

<style scoped>
</style>